import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getLanguageFromPath } from '../../utils/routes';

const content = {
  en: {
    title: 'Terms of Service',
    updated: 'Last updated: May 30, 2026',
    intro: 'By using Tarkov Stash, you agree to these terms. If you do not agree, please do not use the website.',
    sections: [
      ['Use of the Website', 'Tarkov Stash is provided as a community progression tracker and informational guide for Escape from Tarkov players. You agree to use the website lawfully and responsibly.'],
      ['No Warranty', 'The website is provided on an as-is and as-available basis. We do not guarantee that all data is complete, current, or error-free.'],
      ['User Data', 'You are responsible for the accuracy of profile information and progress data you enter. We may update or remove features at any time.'],
      ['Third-Party Content', 'The website may link to third-party services, APIs, communities, and resources. We are not responsible for third-party content or policies.'],
      ['Limitation of Liability', 'Tarkov Stash is not liable for losses, damages, or interruptions arising from use of the website.'],
      ['Contact', 'For questions about these terms, contact contact@tarkovstash.com.'],
    ],
  },
  tr: {
    title: 'Kullanım Şartları',
    updated: 'Son güncelleme: 30 Mayıs 2026',
    intro: 'Tarkov Stash kullanarak bu şartları kabul etmiş olursunuz. Kabul etmiyorsanız lütfen web sitesini kullanmayın.',
    sections: [
      ['Web Sitesinin Kullanımı', 'Tarkov Stash, Escape from Tarkov oyuncuları için topluluk odaklı ilerleme takipçisi ve bilgilendirici rehber olarak sunulur. Siteyi yasal ve sorumlu şekilde kullanmayı kabul edersiniz.'],
      ['Garanti Yoktur', 'Web sitesi olduğu gibi ve mevcut haliyle sunulur. Tüm verilerin eksiksiz, güncel veya hatasız olduğunu garanti etmeyiz.'],
      ['Kullanıcı Verileri', 'Girdiğiniz profil bilgileri ve ilerleme verilerinin doğruluğundan siz sorumlusunuz. Özellikleri herhangi bir zamanda güncelleyebilir veya kaldırabiliriz.'],
      ['Üçüncü Taraf İçerikler', 'Web sitesi üçüncü taraf hizmetlere, API kaynaklarına, topluluklara ve kaynaklara bağlantı verebilir. Üçüncü taraf içeriklerden veya politikalarından sorumlu değiliz.'],
      ['Sorumluluk Sınırı', 'Tarkov Stash, web sitesinin kullanımından doğabilecek kayıp, zarar veya kesintilerden sorumlu değildir.'],
      ['İletişim', 'Bu şartlarla ilgili sorularınız için contact@tarkovstash.com adresine yazabilirsiniz.'],
    ],
  },
};

function TermsOfService() {
  const { language } = useLanguage();
  const location = useLocation();
  const lang = (getLanguageFromPath(location.pathname) || language) === 'tr' ? 'tr' : 'en';
  const copy = content[lang];

  return (
    <main className="max-w-4xl mx-auto px-6 py-12 text-zinc-200">
      <h1 className="text-3xl md:text-4xl font-black text-white mb-3">{copy.title}</h1>
      <p className="text-xs text-zinc-500 mb-8">{copy.updated}</p>
      <p className="text-zinc-300 leading-relaxed mb-8">{copy.intro}</p>
      <div className="space-y-7">
        {copy.sections.map(([title, body]) => (
          <section key={title}>
            <h2 className="text-xl font-bold text-white mb-2">{title}</h2>
            <p className="text-sm leading-7 text-zinc-400">{body}</p>
          </section>
        ))}
      </div>
    </main>
  );
}

export default TermsOfService;
